var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttach = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "attach",
    d: "M16,4.244a4.725,4.725,0,0,1-.381,1.862A4.913,4.913,0,0,1,14.562,7.68l-6.44,6.383-.891-.877L13.672,6.8a3.428,3.428,0,0,0,1.064-2.559,2.876,2.876,0,0,0-2.962-2.962A3.623,3.623,0,0,0,9.186,2.361L2.1,9.391A2.64,2.64,0,0,0,1.251,11.3a1.806,1.806,0,0,0,.532,1.344,1.846,1.846,0,0,0,1.351.525,2.655,2.655,0,0,0,1.926-.848l5.42-5.348a2.2,2.2,0,0,0,.762-1.394.56.56,0,0,0-.23-.474.885.885,0,0,0-.546-.172,1.667,1.667,0,0,0-1.236.575L4.341,10.34l-.877-.877,4.873-4.83a2.942,2.942,0,0,1,2.128-.949,2.1,2.1,0,0,1,1.438.532,1.72,1.72,0,0,1,.6,1.351,3.355,3.355,0,0,1-1.136,2.286L5.952,13.2a3.862,3.862,0,0,1-2.818,1.208A3.061,3.061,0,0,1,.9,13.524,2.985,2.985,0,0,1,0,11.3,3.83,3.83,0,0,1,1.208,8.514l7.087-7.03A4.84,4.84,0,0,1,11.774.032,4.138,4.138,0,0,1,16,4.244Z",
    transform: "translate(-0.014 6.733) rotate(-25)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attach.070ac1bd9d1a8176b6e2e943f3be9063.svg";